// Mock data for Nour L'Fenna Coffee Lounge

export const menuData = {
  coffee: [
    { name: 'Coffee Latte' },
    { name: 'Flat White' },
    { name: 'Cappuccino' },
    { name: 'Coffee Mocha' },
    { name: 'Coffee Americano' },
    { name: 'Espresso' },
    { name: 'Espresso Macchiato' },
    { name: 'Espresso Romano' },
    { name: 'V60' },
    { name: 'Spanish Latte' },
    { name: 'Hot Chocolate' },
    { name: 'Caramel Macchiato' },
    { name: 'Lungo' },
    { name: 'Turkish Coffee' },
    { name: 'Arabic Coffee' },
    { name: 'French Coffee' },
    { name: 'Affogato' }
  ],
  icedCoffee: [
    { name: 'Iced Macchiato' },
    { name: 'Iced Latte' },
    { name: 'Iced Vanilla Latte' },
    { name: 'Iced Chocolate Macchiato' },
    { name: 'Iced Caramel Latte' }
  ],
  tea: [
    { name: 'Earl Grey Tea' },
    { name: 'Pure Chamomile' },
    { name: 'English Breakfast Tea' },
    { name: 'Moroccan Tea' },
    { name: 'Blooming Tea' }
  ],
  juices: [
    { name: 'Orange' },
    { name: 'Mango' },
    { name: 'Strawberry' },
    { name: 'Pomegranate' },
    { name: 'Pineapple' },
    { name: 'Apple' },
    { name: 'Watermelon' },
    { name: 'Carrot' },
    { name: 'Kiwi' },
    { name: 'Lemonade' }
  ],
  mojitos: [
    { name: 'Classic' },
    { name: 'Strawberry' },
    { name: 'Mango' },
    { name: 'Passion Fruit' },
    { name: 'Lemonades' }
  ],
  mocktails: [
    { name: 'Virgin Pina Colada' },
    { name: 'Blue Lagoon' },
    { name: 'Blue Sky' },
    { name: 'Red Bull Berry' },
    { name: 'Sunrise' }
  ],
  milkshakes: [
    { name: 'Vanilla' },
    { name: 'Chocolate' },
    { name: 'Strawberry' },
    { name: 'Oreo' },
    { name: 'Lotus' }
  ],
  desserts: [
    { name: 'Nutella Crepe' },
    { name: 'Lotus Crepe' },
    { name: 'Oreo Crepe' },
    { name: 'Mix Fruits Crepe' },
    { name: 'Pistachio Crepe' },
    { name: 'Nutella Waffle' },
    { name: 'Lotus Waffle' },
    { name: 'Oreo Waffle' },
    { name: 'Strawberry & Chocolate Waffle' },
    { name: 'Pistachio Waffle' },
    { name: 'Nutella Pancake' },
    { name: 'Lotus Pancake' },
    { name: 'Oreo Pancake' },
    { name: 'Mix Fruits Pancake' },
    { name: 'Pistachio Pancake' }
  ],
  shisha: [
    { name: 'Classic Mix - Al Fakher' },
    { name: 'International Tobacco' },
    { name: 'Russian - Starline' },
    { name: 'Turkish - Serbetli - Adalya' },
    { name: 'Signature - Hand Mixes' },
    { name: 'Sunset Love' },
    { name: 'Cola Polar Express' },
    { name: 'Tropicana Breeze' },
    { name: 'Delicious Waffles' },
    { name: 'Premium Shisha' }
  ],
  softDrinks: [
    { name: 'Coca Cola' },
    { name: 'Coca Light' },
    { name: 'Sprite' },
    { name: 'Seven Up' },
    { name: 'Pepsi' },
    { name: 'Fanta' },
    { name: 'Lipton' },
    { name: 'Miranda' },
    { name: 'Barbican' },
    { name: 'Red Bull' },
    { name: 'Water' }
  ]
};

export const testimonials = [
  {
    name: 'Leo Assebe',
    rating: 5,
    text: 'Best shisha lounge in Dubai. The atmosphere, service, and overall experience were excellent from start to finish. The skyline view adds something special, and the shisha, food, and drinks were all prepared to a very high standard.',
    date: 'May 2025'
  },
  {
    name: 'Omar Al Mansoori',
    rating: 5,
    text: 'من أجمل الأماكن التي زرتها في دبي. الأجواء هادئة ومريحة جداً خاصة في المساء، والإطلالة تضيف شيئاً مميزاً للتجربة. الشيشة ممتازة والخدمة كانت سريعة واحترافية. بالتأكيد سأعود مرة أخرى.',
    date: 'May 2025'
  },
  {
    name: 'Brahim Khouaja',
    rating: 5,
    text: 'Really nice late-night spot with a great atmosphere and skyline view. The seating is comfortable, the shisha is excellent, and the overall vibe feels very relaxed. A great place to watch football, meet friends, and unwind after a long day.',
    date: 'May 2025'
  },
  {
    name: 'Sudhakar Chawla',
    rating: 5,
    text: 'One of my favorite things about Nour L\'Fenna was the atmosphere and view. The lounge has a calm late-night energy, and sitting there with the Dubai skyline in the background makes the experience feel different from most cafés and lounges in the city.',
    date: 'May 2025'
  },
  {
    name: 'Sarah Al Kaabi',
    rating: 5,
    text: 'مكان رائع لقضاء الوقت مع الأصدقاء والاستمتاع بإطلالة دبي الجميلة. القهوة كانت ممتازة والشيشة محضرة بعناية. أكثر ما أعجبني هو الراحة والهدوء الموجودان في المكان طوال الليل.',
    date: 'May 2025'
  },
  {
    name: 'Youssef Benali',
    rating: 5,
    text: 'Stopped by with a few friends and ended up staying much longer than expected. The atmosphere is especially enjoyable in the evening, and the view adds a lot to the experience. The drinks, shisha, and service were all excellent throughout the night.',
    date: 'June 2025'
  }
];

export const experiences = [
  {
    title: 'Premium Shisha',
    description: 'Expertly prepared shisha with premium tobacco blends including Al Fakher, Adalya, and our signature hand mixes.',
    icon: 'wind'
  },
  {
    title: 'Specialty Coffee',
    description: 'From authentic Arabic coffee to modern espresso creations, crafted by skilled baristas using premium beans.',
    icon: 'coffee'
  },
  {
    title: 'Live Sports & Match Nights',
    description: 'Catch all major sporting events on our screens while enjoying premium shisha and refreshments with friends.',
    icon: 'trophy'
  },
  {
    title: 'Skyline Atmosphere',
    description: 'Unwind on our rooftop lounge with breathtaking views of the Dubai skyline, perfect for day or night.',
    icon: 'building'
  },
  {
    title: 'Late-Night Gatherings',
    description: 'Open 24/7, we\'re your destination for memorable late-night conversations over coffee and shisha.',
    icon: 'moon'
  }
];

export const gallery = [
  {
    id: 1,
    category: 'atmosphere',
    alt: 'Rooftop lounge atmosphere'
  },
  {
    id: 2,
    category: 'coffee',
    alt: 'Specialty coffee'
  },
  {
    id: 3,
    category: 'shisha',
    alt: 'Premium shisha'
  },
  {
    id: 4,
    category: 'skyline',
    alt: 'Dubai skyline view'
  },
  {
    id: 5,
    category: 'seating',
    alt: 'Comfortable lounge seating'
  },
  {
    id: 6,
    category: 'sports',
    alt: 'Sports viewing area'
  }
];

// Mock API functions
export const mockAPI = {
  submitContactForm: async (formData) => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    console.log('Contact form submitted (MOCK):', formData);
    // Store in localStorage for demo
    const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    submissions.push({ ...formData, id: Date.now(), date: new Date().toISOString() });
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
    return { success: true, message: 'Thank you for contacting us!' };
  },

  subscribeNewsletter: async (email) => {
    await new Promise(resolve => setTimeout(resolve, 800));
    console.log('Newsletter subscription (MOCK):', email);
    const subscribers = JSON.parse(localStorage.getItem('newsletterSubscribers') || '[]');
    if (subscribers.includes(email)) {
      throw new Error('Email already subscribed');
    }
    subscribers.push(email);
    localStorage.setItem('newsletterSubscribers', JSON.stringify(subscribers));
    return { success: true, message: 'Successfully subscribed!' };
  },

  getContactSubmissions: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  },

  getNewsletterSubscribers: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return JSON.parse(localStorage.getItem('newsletterSubscribers') || '[]');
  }
};
